export default "__VITE_ASSET__Dk$Z0Ekg__"